
  (function () {
    var header = document.querySelector('[data-site-header]');
    if (!header || header.dataset.tcgHeaderReady === 'true') return;
    header.dataset.tcgHeaderReady = 'true';

    function hideSearchCategories() {
      header.querySelectorAll('.live-search .live-search-filter-wrapper').forEach(function (wrapper) {
        wrapper.hidden = true;
        wrapper.setAttribute('aria-hidden', 'true');
        wrapper.style.setProperty('display', 'none', 'important');
      });
    }

    hideSearchCategories();
    var liveSearch = header.querySelector('.live-search');
    if (liveSearch) {
      new MutationObserver(hideSearchCategories).observe(liveSearch, { childList: true, subtree: true });
    }

    var accountTemplate = header.querySelector('[data-tcg-mobile-account]');
    var mobileNavRoot = header.querySelector('.site-mobile-nav');
    if (accountTemplate && mobileNavRoot && !mobileNavRoot.querySelector('.tcg-mobile-account')) {
      /* Insert into the menu LIST only — never into the My Account/Logout header toolbar row */
      var mobileMenu =
        mobileNavRoot.querySelector('.site-mobile-nav__content .navmenu') ||
        mobileNavRoot.querySelector('.site-mobile-nav__drawer .navmenu') ||
        mobileNavRoot.querySelector('.site-mobile-nav__panel .navmenu') ||
        mobileNavRoot.querySelector('.navmenu') ||
        mobileNavRoot.querySelector('ul.navmenu') ||
        mobileNavRoot.querySelector('.site-mobile-nav__content > ul') ||
        mobileNavRoot.querySelector('.site-mobile-nav__drawer > ul');

      var accountNode = accountTemplate.content.cloneNode(true);
      var accountEl = accountNode.querySelector ? accountNode.querySelector('.tcg-mobile-account') : null;
      if (!accountEl && accountNode.classList && accountNode.classList.contains('tcg-mobile-account')) {
        accountEl = accountNode;
      }

      if (mobileMenu) {
        mobileMenu.insertBefore(accountNode, mobileMenu.firstChild);
      } else {
        /* Fallback: place as a block between toolbar and first nav list */
        var content =
          mobileNavRoot.querySelector('.site-mobile-nav__content, .site-mobile-nav__drawer, .site-mobile-nav__panel') ||
          mobileNavRoot;
        var firstList = content.querySelector('ul, .navmenu');
        var wrap = document.createElement('div');
        wrap.className = 'tcg-mobile-account';
        if (accountEl) {
          while (accountEl.firstChild) wrap.appendChild(accountEl.firstChild);
        } else {
          wrap.appendChild(accountNode);
        }
        if (firstList && firstList.parentNode) firstList.parentNode.insertBefore(wrap, firstList);
        else content.insertBefore(wrap, content.firstChild);
      }
    }

    function navThemeForLabel(label) {
      var normalized = String(label || '');
      if (normalized.normalize) normalized = normalized.normalize('NFD');
      normalized = normalized.replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim().toLowerCase();

      if (/\b(one piece)\b/.test(normalized)) return 'one-piece';
      if (/\b(disney|lorcana)\b/.test(normalized)) return 'disney';
      if (/\b(digimon)\b/.test(normalized)) return 'digimon';
      if (/\b(pokemon|japanese|scarlet|violet)\b/.test(normalized)) return 'pokemon';
      if (/\b(magic(?: the gathering)?|mtg|lord of the rings|assassin'?s creed)\b/.test(normalized) || /avatar.*last airbender/.test(normalized)) return 'magic';

      return null;
    }

    function applyNavThemes() {
      header.querySelectorAll('.site-navigation, .site-mobile-nav').forEach(function (navRoot) {
        navRoot.querySelectorAll('.navmenu-item').forEach(function (item) {
          var parentItem = item.parentElement && item.parentElement.closest('.navmenu-item[data-tcg-nav-theme]');
          var ownControl = item.querySelector('.navmenu-link, [class*="navmenu-link"], a, button');
          var ownTheme = navThemeForLabel(ownControl && ownControl.textContent);
          var inheritedTheme = parentItem && parentItem.getAttribute('data-tcg-nav-theme');
          item.setAttribute('data-tcg-nav-theme', ownTheme || inheritedTheme || 'default');
        });
      });
    }

    applyNavThemes();
    var themeMobileNav = header.querySelector('.site-mobile-nav');
    if (themeMobileNav) {
      var navThemeFrame = 0;
      new MutationObserver(function () {
        if (navThemeFrame) return;
        navThemeFrame = requestAnimationFrame(function () {
          navThemeFrame = 0;
          applyNavThemes();
        });
      }).observe(themeMobileNav, { childList: true, subtree: true });
    }

    var cart = header.querySelector('.site-header-cart');
    var cartCount = cart && cart.querySelector('[data-header-cart-count]');

    function syncCartVisibility() {
      if (!cart || !cartCount) return;
      var rawCount = cartCount.getAttribute('data-header-cart-count') || cartCount.textContent || '';
      var itemCount = parseInt(String(rawCount).replace(/[^0-9]/g, ''), 10) || 0;
      var hasItems = itemCount > 0;
      cart.setAttribute('data-cart-has-items', hasItems ? 'true' : 'false');
    }

    syncCartVisibility();
    if (cartCount) {
      new MutationObserver(syncCartVisibility).observe(cartCount, {
        attributes: true,
        attributeFilter: ['class', 'data-header-cart-count'],
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    /* ==================================================================
       LIVE CART SYNC
       Every section adds to the basket over AJAX and updates its own count
       selectors - [data-cart-count], .cart-count, #CartCount and so on -
       none of which is this header's [data-header-cart-count]. So the badge
       stayed hidden until the next full page load.

       The header now watches for cart WRITES directly: any request to
       /cart/add|change|update|clear, plus the ll:cart:updated event the
       sections already dispatch. That covers all nine sections, the theme
       and any app, without any of them needing to know the header exists.
       Empty basket still means hidden - only the reveal is now live.
    ================================================================== */
    var cartBusy = false;
    var cartQueued = false;
    var cartLastCount = null;

    function cartRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    function paintCart(count) {
      if (!cart || !cartCount) return;
      var n = parseInt(count, 10);
      if (isNaN(n) || n < 0) n = 0;

      /* ATTRIBUTE ONLY - do not also write textContent.
         Liquid renders this span EMPTY and carries the number in
         data-header-cart-count, because the theme's stylesheet prints it with
         content: attr(data-header-cart-count). Setting the text as well put a
         second number in the same badge: two counts stacked in one grid. */
      cartCount.setAttribute('data-header-cart-count', n > 0 ? String(n) : '');
      if (n > 0) cartCount.classList.add('visible');
      else cartCount.classList.remove('visible');
      cart.setAttribute('data-cart-has-items', n > 0 ? 'true' : 'false');

      /* Pop only when the basket actually grew, never on first paint or on
         removal - otherwise the header twitches on every page load. */
      if (cartLastCount !== null && n > cartLastCount) {
        cart.classList.remove('is-bumped');
        void cart.offsetWidth;            /* restart the animation */
        cart.classList.add('is-bumped');
        setTimeout(function () { cart.classList.remove('is-bumped'); }, 600);
      }
      cartLastCount = n;
    }

    function refreshCart() {
      if (!cart || !cartCount) return;
      if (cartBusy) { cartQueued = true; return; }
      cartBusy = true;
      fetch(cartRoot() + 'cart.js', {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { if (c) paintCart(c.item_count); })
        .catch(function () {})
        .then(function () {
          cartBusy = false;
          if (cartQueued) { cartQueued = false; refreshCart(); }
        });
    }

    if (cart && cartCount && !window.__llHeaderCartSync) {
      window.__llHeaderCartSync = true;

      /* Seed from what Liquid rendered so the first pop is suppressed. */
      var seed = cartCount.getAttribute('data-header-cart-count') || cartCount.textContent || '0';
      cartLastCount = parseInt(String(seed).replace(/[^0-9]/g, ''), 10) || 0;

      var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
      var ping = function () { setTimeout(refreshCart, 120); };

      /* fetch - used by every Lockett Labs section */
      try {
        var _fetch = window.fetch;
        if (typeof _fetch === 'function' && !_fetch.__llHeaderWrapped) {
          var wrapped = function (input) {
            var url = typeof input === 'string' ? input : (input && input.url) || '';
            var out = _fetch.apply(this, arguments);
            if (CART_WRITE.test(String(url))) {
              try { out.then(ping, function () {}); } catch (e) {}
            }
            return out;
          };
          wrapped.__llHeaderWrapped = true;
          window.fetch = wrapped;
        }
      } catch (e) {}

      /* XHR - some apps and older theme code still use it */
      try {
        var _open = XMLHttpRequest.prototype.open;
        if (!_open.__llHeaderWrapped) {
          var openW = function (method, url) {
            this.__llHeaderCartWrite = CART_WRITE.test(String(url || ''));
            return _open.apply(this, arguments);
          };
          openW.__llHeaderWrapped = true;
          XMLHttpRequest.prototype.open = openW;
          var _send = XMLHttpRequest.prototype.send;
          XMLHttpRequest.prototype.send = function () {
            if (this.__llHeaderCartWrite) this.addEventListener('load', ping);
            return _send.apply(this, arguments);
          };
        }
      } catch (e) {}

      /* Events the sections already fire. When the payload carries the cart
         we can paint straight away and skip a round trip. */
      ['ll:cart:updated', 'cart:updated', 'cart:refresh', 'cart:build'].forEach(function (evt) {
        document.addEventListener(evt, function (e) {
          var d = e && e.detail;
          if (d && typeof d.item_count === 'number') paintCart(d.item_count);
          else refreshCart();
        });
      });

      /* Coming back via the back button serves a cached page with a stale
         badge, so re-check on restore and whenever the tab is refocused. */
      window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) refreshCart();
      });

      /* And once on boot, in case something was added on the previous page. */
      refreshCart();
    }

    /* The "/" chip in the field is a promise, so honour it: "/" or Cmd/Ctrl+K
       focuses search. Ignored while typing somewhere else, so it never
       hijacks a real keystroke. */
    (function () {
      var field = header.querySelector(".live-search input:not([type='submit']):not([type='button'])");
      if (!field) return;
      document.addEventListener('keydown', function (e) {
        var slash = e.key === '/' && !e.metaKey && !e.ctrlKey && !e.altKey;
        var cmdK = (e.key === 'k' || e.key === 'K') && (e.metaKey || e.ctrlKey);
        if (!slash && !cmdK) return;

        var t = e.target;
        var tag = t && t.tagName ? t.tagName.toUpperCase() : '';
        if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' ||
            (t && t.isContentEditable)) return;

        e.preventDefault();
        try { field.focus({ preventScroll: false }); } catch (err) { field.focus(); }
        try { field.select(); } catch (err2) {}
      });
    })();

    /* ==================================================================
       TYPING PLACEHOLDER
       The field cycles real product titles so the search suggests what it
       can actually find, rather than sitting on one generic prompt.

       Rules it has to respect:
         · never while the field is focused or has a value - it must never
           look like text the shopper typed
         · the ORIGINAL placeholder is restored on focus and on teardown
         · nothing runs while the tab is hidden, or under reduced motion
    ================================================================== */
    (function () {
      var form = header.querySelector('.live-search form');
      var field = header.querySelector(".live-search input:not([type='submit']):not([type='button'])");
      if (!form || !field) return;

      var raw = document.getElementById('tcg-search-hints');
      var hints = [];
      try { hints = JSON.parse(raw ? raw.textContent : '[]') || []; } catch (e) { hints = []; }
      hints = hints.filter(function (h) { return h && h.length > 2; });
      if (!hints.length) return;

      var base = field.getAttribute('placeholder') || '';
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) return;

      /* Shuffle so every visit does not open on the same product. */
      for (var i = hints.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = hints[i]; hints[i] = hints[j]; hints[j] = t;
      }

      var TYPE = 55, ERASE = 26, HOLD = 1700, GAP = 420;
      var idx = 0, ch = 0, erasing = false, timer = null, stopped = false;

      function idle() {
        return document.activeElement !== field && !field.value && !document.hidden;
      }

      function step() {
        if (stopped) return;
        if (!idle()) { schedule(500); return; }

        var word = hints[idx % hints.length];
        if (!erasing) {
          ch++;
          field.setAttribute('placeholder', word.slice(0, ch));
          if (ch >= word.length) { erasing = true; schedule(HOLD); return; }
          schedule(TYPE);
        } else {
          ch--;
          field.setAttribute('placeholder', ch > 0 ? word.slice(0, ch) : base);
          if (ch <= 0) { erasing = false; idx++; schedule(GAP); return; }
          schedule(ERASE);
        }
      }

      function schedule(ms) {
        clearTimeout(timer);
        timer = setTimeout(step, ms);
      }

      function restore() {
        clearTimeout(timer);
        ch = 0; erasing = false;
        field.setAttribute('placeholder', base);
      }

      /* Focus hands the field back immediately - the shopper should never be
         typing over a moving target. */
      field.addEventListener('focus', function () { restore(); });
      field.addEventListener('blur', function () { if (!field.value) schedule(900); });
      field.addEventListener('input', function () { if (field.value) restore(); });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) clearTimeout(timer);
        else if (idle()) schedule(700);
      });

      document.addEventListener('shopify:section:unload', function () {
        stopped = true; restore();
      });

      schedule(1400);   /* let the page settle before anything moves */
    })();

    var mobileNav = header.querySelector('.site-mobile-nav');
    var menuToggle = header.querySelector('[data-menu-toggle]');

    document.documentElement.removeAttribute('data-mobile-menu-open');

    function explicitMobileNavState() {
      var expanded = menuToggle && menuToggle.getAttribute('aria-expanded');
      var hidden = mobileNav && mobileNav.getAttribute('aria-hidden');
      var stateClasses = mobileNav ? String(mobileNav.className || '') : '';

      if (expanded === 'true' || hidden === 'false' || /(^|\s)(is-open|open|visible|active)(\s|$)/i.test(stateClasses)) {
        return true;
      }

      if (expanded === 'false' || hidden === 'true') return false;

      return null;
    }

    function mobileNavLooksOpen() {
      if (!mobileNav || window.innerWidth > 1024) return false;

      var surface = mobileNav.querySelector('.site-mobile-nav__drawer, .site-mobile-nav__panel, .site-mobile-nav__content') || mobileNav;
      var navStyle = window.getComputedStyle(mobileNav);
      var surfaceStyle = window.getComputedStyle(surface);
      var rect = surface.getBoundingClientRect();
      var hiddenByStyle = navStyle.display === 'none' || navStyle.visibility === 'hidden' || parseFloat(navStyle.opacity || '1') === 0;
      var surfaceHidden = surfaceStyle.display === 'none' || surfaceStyle.visibility === 'hidden' || parseFloat(surfaceStyle.opacity || '1') === 0;
      var outsideViewport = rect.width <= 1 || rect.height <= 1 || rect.right <= 0 || rect.bottom <= 0 || rect.left >= window.innerWidth || rect.top >= window.innerHeight;

      return !hiddenByStyle && !surfaceHidden && !outsideViewport;
    }

    function syncMobileNavState() {
      var explicitState = explicitMobileNavState();
      var isOpen = explicitState === null ? mobileNavLooksOpen() : explicitState;
      header.toggleAttribute('data-tcg-mobile-nav-open', isOpen);
    }

    function syncAfterThemeUpdate() {
      requestAnimationFrame(function () {
        requestAnimationFrame(syncMobileNavState);
      });
    }

    if (menuToggle) {
      menuToggle.addEventListener('click', syncAfterThemeUpdate, { passive: true });
    }

    if (mobileNav) {
      mobileNav.addEventListener('click', syncAfterThemeUpdate, { passive: true });
      mobileNav.addEventListener('transitionend', syncMobileNavState);

      new MutationObserver(syncMobileNavState).observe(mobileNav, {
        attributes: true,
        attributeFilter: ['aria-hidden', 'aria-expanded', 'class', 'style']
      });
    }

    if (menuToggle) {
      new MutationObserver(syncMobileNavState).observe(menuToggle, {
        attributes: true,
        attributeFilter: ['aria-expanded', 'class']
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') syncAfterThemeUpdate();
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth > 1024) {
        header.removeAttribute('data-tcg-mobile-nav-open');
      } else {
        syncAfterThemeUpdate();
      }
    }, { passive: true });

    syncMobileNavState();
  }());
